/**
 * In-session Compliance Queue status overrides (e.g. New → Under Review on first open).
 * Sample cases stay in their source files.
 */

const overrides = new Map();

const keyOf = (caseId) => String(caseId || '').trim();

export function getComplianceCaseOverride(caseId) {
  return overrides.get(keyOf(caseId)) || null;
}

export function patchComplianceCaseOverride(caseId, patch) {
  const key = keyOf(caseId);
  if (!key) return null;
  const next = { ...(overrides.get(key) || {}), ...patch };
  overrides.set(key, next);
  return next;
}

const normalizeComplianceQueueStatus = (status) =>
  status === 'Information Requested' ? 'Awaiting Information' : status;

export function applyComplianceQueueSession(row) {
  if (!row?.compliance_id) return row;
  const patch = getComplianceCaseOverride(row.compliance_id);
  const status = normalizeComplianceQueueStatus(patch?.status || row.case_status);
  if (!patch && status === row.case_status) return row;
  return {
    ...row,
    case_status: status,
    verification_status: status,
    last_updated: patch?.lastUpdated || row.last_updated,
  };
}
